import { render, staticRenderFns } from "./literature.vue?vue&type=template&id=e8c3b23c&scoped=true&"
import script from "./literature.vue?vue&type=script&lang=ts&"
export * from "./literature.vue?vue&type=script&lang=ts&"
import style0 from "./literature.vue?vue&type=style&index=0&id=e8c3b23c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c3b23c",
  null
  
)

export default component.exports